/* ============================================================================
   TUC TUC & FRIENDS — Home reveal allo scroll (IntersectionObserver leggero).
   Aggiunge .is-visible alle .tuctuc-home-reveal quando entrano nel viewport.
   Idempotente. Rispetta prefers-reduced-motion. Nessuna libreria esterna.
   Rete di sicurezza: se per qualunque motivo l'observer non rivela un elemento,
   dopo un timeout tutto viene comunque mostrato (mai contenuti invisibili).
   ============================================================================ */
(function () {
  if (window.__tuctucHomeCinematic) return;
  window.__tuctucHomeCinematic = true;

  var root = document.documentElement;
  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(els) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-visible');
  }

  function init() {
    var els = document.querySelectorAll('.tuctuc-home-reveal');
    if (!els.length) return;

    // Da qui la CSS puo' nascondere (prima del reveal). Senza JS resta visibile.
    root.classList.add('tuctuc-home-reveal-ready');

    if (reduce || !('IntersectionObserver' in window)) {
      showAll(els);
      return;
    }

    // Bidirezionale: appare entrando nel viewport, scompare (shrink+fade) uscendo.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
        } else {
          e.target.classList.remove('is-visible');
        }
      });
    }, { root: null, rootMargin: '-6% 0px -10% 0px', threshold: 0.18 });

    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
